import React, { createContext, useContext, useState, useEffect } from 'react';

export type Currency = 'USD' | 'EUR' | 'ALL';

interface CurrencyContextType {
    currency: Currency;
    setCurrency: (currency: Currency) => void;
}

const CurrencyContext = createContext<CurrencyContextType | undefined>(undefined);

export const CurrencyProvider: React.FC<{ children: React.ReactNode; initialCurrency: Currency }> = ({ children, initialCurrency }) => {
    const [currency, setCurrencyState] = useState<Currency>(initialCurrency);

    useEffect(() => {
        setCurrencyState(initialCurrency);
    }, [initialCurrency]);

    const setCurrency = (newCurrency: Currency) => {
        setCurrencyState(newCurrency);
    };

    return (
        <CurrencyContext.Provider value={{ currency, setCurrency }}>
            {children}
        </CurrencyContext.Provider>
    );
};

export const useCurrency = () => {
    const context = useContext(CurrencyContext);
    if (context === undefined) {
        throw new Error('useCurrency must be used within a CurrencyProvider');
    }
    return context;
};
